import React, { useEffect, useState } from "react";
import { Users, Snowflake, Compass, HeartHandshake } from "lucide-react";
import { api } from "@/lib/api";

const ICONS = [Users, Snowflake, Compass, HeartHandshake];

export default function About() {
  const [data, setData] = useState(null);
  useEffect(() => {
    api.get("/about").then((r) => setData(r.data)).catch(() => {});
  }, []);

  const eyebrow = data?.eyebrow || "Our Story";
  const heading = data?.heading || "About Global Compass";
  const sections = data?.sections || [];
  const paragraphs = data?.paragraphs || [];
  const highlights = data?.highlights || [];
  const affiliations = data?.affiliations || [];

  return (
    <div className="bg-ivory">
      <div className="bg-maroon text-amber-50 py-16 relative overflow-hidden">
        <div className="absolute inset-0 grain pointer-events-none opacity-30" />
        <div className="relative max-w-7xl mx-auto px-4">
          <div className="text-amber-300 text-sm font-semibold tracking-widest uppercase mb-3">{eyebrow}</div>
          <h1 className="font-display text-4xl sm:text-5xl lg:text-6xl font-extrabold leading-tight" data-testid="about-heading">{heading}</h1>
        </div>
      </div>
      <div className="max-w-4xl mx-auto px-4 py-16 space-y-10 text-lg text-slate-700 leading-relaxed">
        {sections.length > 0 ? (
          sections.map((s, i) => (
            <section key={i} data-testid={`about-section-${i}`}>
              <h2 className="font-display text-2xl sm:text-3xl font-bold text-maroon mb-3">{s.title}</h2>
              {(s.body || "").split("\n\n").map((para, pi) => (
                <p key={pi} className="mb-4 last:mb-0">{para}</p>
              ))}
            </section>
          ))
        ) : (
          paragraphs.map((p, i) => (
            <p key={i} data-testid={`about-paragraph-${i}`}>{p}</p>
          ))
        )}
        {highlights.length > 0 && (
          <div className="grid sm:grid-cols-2 gap-4 pt-4" data-testid="about-highlights">
            {highlights.map((title, i) => {
              const Icon = ICONS[i % ICONS.length];
              return (
                <div key={i} className="flex items-center gap-4 bg-white rounded-xl p-5 border border-amber-900/10" data-testid={`about-highlight-${i}`}>
                  <span className="w-14 h-14 rounded-full bg-amber-100 text-maroon grid place-items-center shrink-0"><Icon size={26} /></span>
                  <span className="font-display text-xl font-bold text-maroon">{title}</span>
                </div>
              );
            })}
          </div>
        )}
        {affiliations.map((affiliation, index) => (
          <div
            className="flex items-center gap-5 bg-white rounded-xl p-6 border border-amber-900/10"
            data-testid={`about-affiliation-${index}`}
            key={`${affiliation.title}-${index}`}
          >
            <img
              src={affiliation.imageUrl || "/tafi.jpg"}
              alt={affiliation.title}
              className="w-20 aspect-square object-contain shrink-0"
            />
            <div>
              <div className="font-display text-xl font-bold text-maroon">
                {affiliation.title}
              </div>
              <div className="text-slate-600 text-base">{affiliation.description}</div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
